module.exports = __webpack_public_path__ + "static/media/icon-collection-green.09bb6f2c.svg";